import { StatelessComponent } from 'react'
import * as styles from 'styles/organisms/CreditLinkageCompletion.css'
import GatherHeader from 'components/features/pfm/GatherHeader/GatherHeader'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Button from 'components/features/pfm/Button/Button'
import MemberCreditChartContainer from 'components/features/pfm/CreditChart/MemberCreditChartContainer'

const title = (
  <div>
    Congratulations!
    <br />
    Your credit file has been
    successfully linked.
  </div>
)

const CreditLinkageCompletion: StatelessComponent = () => (
  <section className={ styles.creditLinkageCompletion }>
    <GatherHeader title={ title }>
      <p className={ styles.subtitleParagraph }>
        You can now compare your credit score and see all the accounts on your TransUnion® credit report.
      </p>
      <p className={ styles.subtitleParagraph }>
        Status will also monitor your credit report and alert you when any new accounts are opened in your name.
      </p>
    </GatherHeader>
    <section className={ styles.summary }>
      <MemberCreditChartContainer />
    </section>
    <section className={ styles.buttonContainer }>
      <NavigationLink to='creditscore'>
        <Button size='medium' fullWidth>
          View your credit profile now
        </Button>
      </NavigationLink>
    </section>
  </section>
)

export default CreditLinkageCompletion
